import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { getMe } from "./api";
import socket from "./socket";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import "./App.css";

/**
 * Composant racine — Sobeca
 * Gère l'état d'authentification et le routage login/dashboard.
 */
function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Vérifier si l'utilisateur est déjà connecté (cookie de session)
  useEffect(() => {
    getMe()
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error("Non connecté");
      })
      .then((data) => {
        setUser(data.user);
        socket.connect();
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = (u) => {
    setUser(u);
    socket.connect();
  };

  const handleLogout = () => {
    setUser(null);
    socket.disconnect();
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <span role="img" aria-label="chantier" className="loading-icon">&#x1F3D7;</span>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            user ? (
              <Navigate to="/" replace />
            ) : (
              <LoginPage onLogin={handleLogin} />
            )
          }
        />
        <Route
          path="/"
          element={
            user ? (
              <Dashboard user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
